import { FormattedMessage } from 'components/Commons/Translation'
import { HOME } from 'routes'

import { Container, HugeMessage, StyledButton } from './styled'

import translations from './translations'

function Page({ title, message }) {
  return (
    <Container>
      <HugeMessage>
        <FormattedMessage {...translations.oops} />
      </HugeMessage>
      <h3>
        <FormattedMessage {...title} />
      </h3>
      <div>
        <FormattedMessage {...message} />
      </div>
      <StyledButton href={HOME()}>
        <FormattedMessage {...translations.homepage} />
      </StyledButton>
    </Container>
  )
}

export default Page
